import { useSdk } from '~/sdk';
import type {
  UseOrdersReturn,
  UseOrdersState,
  FetchOrders,
  FetchOrderDetails
} from '~/composables/useOrders/types';

export const useOrders = () => {
  const state = useState<UseOrdersState>(`useOrders`, () => ({
    orders: null,
    loading: false,
    currentOrder: null
  }));

  const { send } = notifications();
  const { $i18n } = useNuxtApp();

  const fetchOrders = async () => {
    state.value.loading = true

    try {
      const data = await useSdk().commerce.getOrders();
      state.value.orders = data;
    } catch (error) {
      useHandleError(error);
    } finally {
      state.value.loading = false;
    }
  }

  const fetchOrderDetails: FetchOrderDetails = async (id) => {
    state.value.loading = true
    state.value.currentOrder = await useSdk().commerce.getOrder({ id_order: id });
    state.value.loading = false;
  }

  return {
    fetchOrders,
    fetchOrderDetails,
    ...toRefs(state.value)
  };
}
